module.exports = __webpack_public_path__ + "img/rugbyLes.d63a72c2.gif";